import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { authMe, authLogout } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
    } catch (err) {
      // Expected when unauthenticated — surface unexpected errors to the console for debugging.
      if (err?.response?.status !== 401 && err?.response?.status !== 403) {
        // eslint-disable-next-line no-console
        console.error("Auth check failed:", err);
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, skip /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    check();
  }, [check]);

  const logout = useCallback(async () => {
    try { await authLogout(); } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Logout failed:", err);
    }
    setUser(null);
    window.location.href = "/admin/login";
  }, []);

  const value = useMemo(
    () => ({ user, setUser, loading, refresh: check, logout }),
    [user, loading, check, logout],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
